import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Space, Tag } from 'antd';
import styled from 'styled-components';

import { MpTitle } from 'shared/ui/MpTitle';

interface ApplicationCategoriesMProps {
	categories: string[];
}

const TagStyled = styled(Tag)`
	padding: 0 8px;
	border: 1px solid #d9d9d9;
	background-color: #fff;
	font-size: 14px;
	line-height: 22px;
`;

const CATEGORY_SPACE_SIZE_HORIZONTAL = 0;
const CATEGORY_SPACE_SIZE_VERTICAL = 4;

export const ApplicationCategoriesM: FC<ApplicationCategoriesMProps> = ({ categories }) => {
	const { t } = useTranslation();

	return (
		<div style={{ marginBottom: `24px` }}>
			<MpTitle>{t(`Marketplace_Categories`)}</MpTitle>
			<Space size={[CATEGORY_SPACE_SIZE_HORIZONTAL, CATEGORY_SPACE_SIZE_VERTICAL]} wrap>
				{categories.map(category => (
					<TagStyled key={category}>{category}</TagStyled>
				))}
			</Space>
		</div>
	);
};
